export { default as ColorThermometer } from './ColorThermometer';
